<template>
  <div v-if="cart" class="relative">
    <a :href="cart.attributes.urls.checkout" class="border bg-white rounded-full px-4 py-2 font-semibold flex items-center gap-2 cursor-pointer text-sm">
      {{  i18n.t('marketplace.general.cart')  }}
      <template v-if="leftTime > 0">
        <span>|</span>
        {{ leftTimeString }}
      </template>
    </a>
    <div v-if="false" class="w-80 bg-white shadow rounded p-4 z-20 absolute right-0">
      <template v-if="cartItems.length == 0">
        <span class="text-jt-dark-grey text-sm">
          {{ i18n.t('cart.empty_cart') }}
        </span>
      </template>
      <template v-else>
        <div class="text-sm mb-4">
          {{ i18n.t('cart.active_cart') }}<br>
          {{ cart.attributes.start_date }} - {{ cart.attributes.end_date }}
        </div>
        <div v-for="item in sortedItems" :key="item.id" class="flex items-center gap-2">
          <div class="flex flex-col">
            <span class="text-jt-dark-grey text-sm font-bold">
              {{ item.attributes.name }} x {{ item.attributes.quantity }}
            </span>
            <span class="text-jt-dark-grey text-sm">
              {{ item.attributes.price }} {{ item.attributes.price_unit }}
            </span>
          </div>
          <div class="flex gap-2 ml-auto text-lg opacity-60">
            <div class="text-jt-dark-grey  cursor-pointer" @click="changeQuantity(item.attributes.item_id, -1)">
              <i v-if="item.attributes.quantity > 1" class="bi bi-dash-circle"></i>
              <i v-else class="bi bi-trash"></i>
            </div>
            <div class="text-jt-dark-grey  cursor-pointer" @click="changeQuantity(item.attributes.item_id, 1)">
              <i class="bi bi-plus-circle"></i>
            </div>
          </div>
        </div>
        <hr class="my-4">
        <div class="flex items-center">
          <a class="jt-btn mr-auto" :href="cart.attributes.urls.checkout" @click="openCart=false">
            {{ i18n.t('cart.to_checkout') }}
          </a>
          {{ i18n.t('general.total') }}
          :
          <b>{{ cart.attributes.total_with_vat }} {{ cart.attributes.price_unit }}</b>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Cart',
  props: {
    cart: Object,
    cartItems: Array,
    timeSeconds: String
  },
  data: function() {
    return {
      openCart: false,
      leftTime: null
    }
  },
  watch: {
    cart: function() {
      if (this.cart) {
        if (this.leftTime > 0) return;
        let diffTime = new Date().getTime() - Date.parse(this.cart.attributes.created_at);
        diffTime = diffTime / 1000;
        this.leftTime = this.timeSeconds - diffTime;
        this.startCounter();
      } else {
        this.leftTime = null;
      }
    }
  },
  computed: {
    sortedItems: function() {
      return this.cartItems.sort((a, b) => { return a.attributes.name - b.attributes.name });
    },
    leftTimeString: function() {
      let minutes = Math.floor(this.leftTime / 60);
      let seconds = Math.floor(this.leftTime - minutes * 60);
      if (seconds < 10) seconds = `0${seconds}`;
      if (minutes < 10) minutes = `0${minutes}`;
      return `${minutes}:${seconds}`;
    }
  },
  methods: {
    changeQuantity: function(itemId, quantity) {
      this.$emit('update-cart', itemId, quantity);
    },
    startCounter: function() {
      if (this.leftTime < 0) {
        this.$emit('clearCart');
        return
      }

      setTimeout(() => {
        this.leftTime -= 1;
        this.startCounter();
      }, 1000);
    }
  }
}
</script>
